import React from 'react';
import { ConversationsLayout } from '../../../../../layouts/ConversationsLayout';

export const ConversationFullView  = (props) => {

		const { children, location } = props;

		return (
			<article className="container conversation-body">
				<ConversationsLayout location={ location } >
					{ 
						children 
					}
				</ConversationsLayout>
			</article>
		);
	};



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/ConversationFullView.js